import { subDays } from 'date-fns';

import { CreditCardTransaction, CustomerRole, SimplePage } from '@generated-types';

export const kredittbankenTransactionsMock1: SimplePage<CreditCardTransaction> = {
    hasNextPage: false,
    page: 0,
    elements: [
        {
            description: 'decription on',
            id: '1',
            postAmount: 3543,
            postDate: new Date(),
            transactionDate: new Date(),
            categoryDescription: 'categoryDescription',
            groupDescription: 'groupDescription',
        },
        {
            id: '2f35f778-6e1d-7cf0-e063-c4a5f60acb6a',
            postAmount: -1820.86,
            postDate: subDays(new Date(), 3),
            transactionDate: subDays(new Date(), 4),
            description: 'A CASH HERE ARUSHA',
            cardNumber: '406676******4939',
            cardHolderFirstName: 'UEMOSJONELL',
            cardHolderLastName: 'RYPE',
            cardHolderRole: CustomerRole.ACCOUNT_OWNER,
            categoryDescription: undefined,
            groupDescription: 'Kontantuttak utland',
        },
        {
            id: '007f874c-2a92-48e0-8968-d116dc41c402',
            postAmount: -4900.0,
            postDate: subDays(new Date(), 3),
            transactionDate: subDays(new Date(), 4),
            description: 'A Overføring til konto 12345678910',
            cardNumber: undefined,
            cardHolderFirstName: undefined,
            cardHolderLastName: undefined,
            cardHolderRole: undefined,
            categoryDescription: undefined,
            groupDescription: 'Overføring kort til konto',
        },
        {
            id: '001c656d-2fd2-440f-b1bb-b4ff51a67068',
            postAmount: -120.0,
            postDate: subDays(new Date(), 3),
            transactionDate: subDays(new Date(), 4),
            description: 'A Årsgebyr',
            cardNumber: undefined,
            cardHolderFirstName: undefined,
            cardHolderLastName: undefined,
            cardHolderRole: undefined,
            categoryDescription: undefined,
            groupDescription: 'Årsgebyr',
        },
        {
            id: '0016c166-6b55-4800-a743-587420d7feef',
            postAmount: -9.78,
            postDate: subDays(new Date(), 3),
            transactionDate: subDays(new Date(), 4),
            description: 'A Overtrekksrente',
            cardNumber: undefined,
            cardHolderFirstName: undefined,
            cardHolderLastName: undefined,
            cardHolderRole: undefined,
            categoryDescription: undefined,
            groupDescription: 'Overtrekksrente',
        },
    ],
};
